module.exports = __webpack_public_path__ + "static/media/deviantart.85b3737b.svg";